import { useState, useEffect } from "react";

import { useLocale } from "@kolaymeeting/lib/hooks/useLocale";
import { localStorage } from "@kolaymeeting/lib/webstorage";
import classNames from "@kolaymeeting/ui/classNames";

type LoginType = "saml" | "google" | "microsoft" | "credentials" | "basefyio-credentials" | "authfyio";

export function useLastUsed() {
  const [lastUsed, setLastUsed] = useState<LoginType>();

  useEffect(() => {
    const storedValue = localStorage.getItem("last_cal_login");
    if (storedValue) {
      setLastUsed(storedValue as LoginType);
    }
  }, []);

  useEffect(() => {
    if (lastUsed) {
      localStorage.setItem("last_cal_login", lastUsed);
    } else {
      localStorage.removeItem("last_cal_login");
    }
  }, [lastUsed]);

  return [lastUsed, setLastUsed] as const;
}

export const LastUsed = ({ className }: { className?: string }) => {
  const { t } = useLocale();
  return (
    <span className={classNames("text-subtle absolute right-3 text-xs", className)}>{t("last_used")}</span>
  );
};
